
import { createContext, useContext, useEffect, useState } from 'react';
import { startLoading, stopLoading, subscribeLoading } from './loadingEvents';

const LoadingContext = createContext({
  loading: false,
  show: () => {},
  hide: () => {},
});

export const LoadingProvider = ({ children }: any) => {
  const [activeRequests, setActiveRequests] = useState(0);

  useEffect(() => {
    const unsubscribe = subscribeLoading(setActiveRequests);
    return unsubscribe;
  }, []);

  const value = {
    loading: activeRequests > 0,
    show: () => startLoading(),
    hide: () => stopLoading(),
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);
